import React from 'react';

import { useParams } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import ThreadDetailItem from '../components/forum/thread/ThreadDetailItem';

import {
  asyncDownVoteThreadDetail,
  asyncNeutralVoteThreadDetail,
  asyncReceiveThreadDetail,
  asyncUpVoteThreadDetail,
} from '../middleware/threadDetail/action';
import { asyncCreateComment } from '../middleware/comment/action';

const ThreadDetailPage = () => {
  const dispatch = useDispatch();
  const { threadId } = useParams();
  const {
    threadDetail = null,
    authUser,
  } = useSelector((states) => states);

  React.useEffect(() => {
    dispatch(asyncReceiveThreadDetail(threadId));
  }, [threadId, dispatch]);

  const onCreateComment = (content) => {
    dispatch(asyncCreateComment({ threadId, content }));
  };

  const onDownVoteThread = () => {
    dispatch(asyncDownVoteThreadDetail(threadId));
  };

  const onNeutralVoteThread = () => {
    dispatch(asyncNeutralVoteThreadDetail(threadId));
  };

  const onUpVoteThread = () => {
    dispatch(asyncUpVoteThreadDetail(threadId));
  };

  if (!threadDetail) {
    return null;
  }

  return (
    <ThreadDetailItem
      {...threadDetail}
      authUser={authUser}
      onCreateComment={onCreateComment}
      onUpVotesThread={onUpVoteThread}
      onNeutralsVotesThread={onNeutralVoteThread}
      onDownsVotesThread={onDownVoteThread}
    />
  );
};

export default ThreadDetailPage;
